import type { FetchConfig } from '../helper-types';
import type { paths } from './portal-api-definition';

export function createNloNavigationApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		getNavigationConfig() {
			return client.GET('/api/my/common/navigation/emergency-banner');
		},
	};
}
